export default __webpack_public_path__ + "static/media/failed.1b40c46c.png";